import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.community.group');
import { OnInit, OnDestroy, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcadmin-community-group',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.community.group/view.scss */
/* src/app/portal.gsdcadmin.community.group/view.scss: no such file or directory */`],
})
export class PortalGsdcadminCommunityGroupComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) { }
    @Input() community_id: any;
    public groups: any[] = [];
    public searchTerm = '';
    public page = 1;
    public total = 0;
    public lastpage = 1;
    public loading = false;
    public failed = false;
    private requestId = 0;

    public async ngOnInit() {
        await this.service.init();
        const query = new URLSearchParams(window.location.search);
        this.page = Math.max(1, Number(query.get('page')) || 1);
        this.searchTerm = query.get('q') || '';
        await this.load();
    }
    public ngOnDestroy() { this.requestId++; }
    public get pages(): number[] {
        const first = Math.max(1, Math.min(this.page - 2, this.lastpage - 4));
        return Array.from({length: Math.min(5, this.lastpage)}, (_, i) => first + i);
    }
    public get listQuery() { return {page: this.page > 1 ? this.page : null, q: this.searchTerm.trim() || null}; }
    public async search() { this.page = 1; await this.load(); }
    public async pageLoad(page: number) {
        if (this.loading || page < 1 || page > this.lastpage || page === this.page) return;
        this.page = page;
        await this.load();
    }
    public async load() {
        const request = ++this.requestId;
        this.loading = true; this.failed = false;
        await this.service.render();
        try {
            const {code, data} = await wiz.call('load', {id: this.community_id, text: this.searchTerm.trim(), page: this.page});
            if (request !== this.requestId) return;
            if (code !== 200 || !Array.isArray(data?.groups)) throw new Error('load');
            this.groups = data.groups;
            this.total = data.total ?? data.groups.length;
            this.page = data.page || 1;
            this.lastpage = data.lastpage || 1;
            const url = new URL(window.location.href);
            for (const [key, value] of Object.entries(this.listQuery))
                value === null ? url.searchParams.delete(key) : url.searchParams.set(key, String(value));
            window.history.replaceState(window.history.state, '', url.toString());
        } catch (_) {
            if (request === this.requestId) { this.failed = true; this.groups = []; }
        } finally {
            if (request === this.requestId) { this.loading = false; await this.service.render(); }
        }
    }
}

export default PortalGsdcadminCommunityGroupComponent;